import cs from 'classnames';

import Icon from '../../Icon/Icon';

const Image = ({ url, icon, loading, className }) => (
  <div
    className={cs(
      'flex h-16 w-16 items-center justify-center rounded-full',
      loading && 'border border-solid border-neutral-100',
      className
    )}>
    {loading ? (
      <Icon icon="loader-linear" className="animate-spin" size={20} />
    ) : url ? (
      <img src={url} alt="image" className="h-full w-full rounded-full object-cover" />
    ) : (
      <Icon icon={icon} size={64} />
    )}
  </div>
);

export default Image;
